// src/routes/index.tsx
import {
  createFileRoute,
  useNavigate,
} from '@tanstack/react-router';
import AuthForm from '@/components/Auth';
import { useAuth } from '@/lib/auth';
import Loader from '@/components/Loader';
import { isEvalsHost } from '@/api/config';
import { useEffect } from 'react';
import { GreetLogo } from '@/components/brand/GreetLogo';

export const Route = createFileRoute('/')({
  component: HomePage,
  ssr: true,
  head: () => {
    const title = 'GreetAI - AI Voice Agent Platform';
    const description =
      'Create custom AI voice agent sessions for screening, training and evaluation. Design, deploy and analyze results in minutes.';
    const url = 'https://app.greetai.co';
    const image =
      'https://vercel-og-boards.vercel.app/api/tailwind?title=GreetAI&website=AI Voice Agent Platform';

    return {
      title,
      meta: [
        {
          name: 'title',
          property: 'og:title',
          content: title,
        },
        {
          name: 'description',
          property: 'og:description',
          content: description,
        },
        {
          property: 'og:image',
          content: image,
        },
        {
          property: 'og:url',
          content: url,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          property: 'twitter:domain',
          content: 'greetai.co',
        },
        {
          property: 'twitter:url',
          content: url,
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: description,
        },
        {
          name: 'twitter:image',
          content: image,
        },
      ],
    };
  },
});

function HomePage() {
  const navigate = useNavigate();
  const { isAuthenticated, isInitialLoading } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate({ to: isEvalsHost ? '/evals' : '/dashboard' });
    }
  }, [isAuthenticated, navigate]);

  if (isInitialLoading || isAuthenticated) {
    return <Loader />;
  }

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-white dark:bg-gray-950 px-5 py-8">
      <div className="w-full max-w-sm">
        <GreetLogo className="h-8 w-auto mb-8" />
        <AuthForm />
      </div>
    </div>
  );
}
